export enum ProgressActionType {
  'MAIL',
  'OPERATION',
  'EDITOR',
  'DELETE',
  'DIALOG',
}
